import script from "./procurePayDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./procurePayDetail.vue?vue&type=script&setup=true&lang=js"

import "./procurePayDetail.vue?vue&type=style&index=0&id=e506931c&lang=less"

const __exports__ = script;

export default __exports__